var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box",staticStyle:{"padding":"0px"}},[_c('div',{staticClass:"boxTitle",staticStyle:{"margin":"15px"}},[_vm._v("关口代表企业")]),_vm._v(" "),_c('div',{staticClass:"echart"},[_c('dv-scroll-board',{staticStyle:{"width":"100%","height":"30vh"},attrs:{"config":_vm.config}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c2aa2d7","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/left/two.vue
// module id = null
// module chunks = 